export default {
  permissionDenied: {
    text: "permission denied",
    code: "permissionDenied",
    statusCode: 403,
  },
  notFound: {
    text: "not found",
    code: "notFound",
    statusCode: 404,
  },
};



// WEBPACK FOOTER //
// ./src/error-codes.js